import addValidationMessage from '../utils/translation/addValidationMessage';
import requiredValidator from './requiredValidator';

addValidationMessage('Core/emailValidator', 'email', {
  fr: 'Le courriel n\'est pas valide',
  en: 'The email is not valid',
});

const emailValidator = (value: string) => {
  if (!requiredValidator(value)) {
    return true;
  }

  return /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(value);
};

/**
 * @component
 * @visibleName emailValidator
 */
export default emailValidator;
